var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1109 3.21978L14.6251 5.73443M9.88889 16.9996H17M1 17L1.04218 16.7047C1.19143 15.6597 1.26606 15.1372 1.43581 14.6494C1.58644 14.2166 1.79221 13.805 2.04805 13.4247C2.33636 12.9962 2.7095 12.623 3.45577 11.8766L13.8095 1.5208C14.5038 0.826405 15.6294 0.826396 16.3237 1.5208C17.018 2.2152 17.018 3.34105 16.3237 4.03545L5.77995 14.5812C5.10293 15.2584 4.76442 15.597 4.37884 15.8663C4.0366 16.1052 3.66749 16.3032 3.27909 16.4562C2.84152 16.6284 2.37222 16.7231 1.43372 16.9125L1 17Z",
    stroke: "#176318",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c136711bef29cabb488c63e1f718bdcf.svg";
export { ForwardRef as ReactComponent };